import React from "react";
import {
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Row,
  Col,
} from "reactstrap";

import {
  SalesSummary,
  Users,
  Feeds,
  EmailedToday,
  UserViseEmail,
  UserViseWeeklyEmail,
  EmailQuerter,
  ContentHeader,
  FinancialTable
} from "components/dashboard-components";

// import FinancialTable from "../../components/dashboard-components/email-track/testTable";
// import ClosingDeals from "../../components/dashboard-components/deals/ClosingDeals.js"
import ClosingDeals from "../../components/dashboard-components/deals/ClosingDeals";
import MonthlyChart from "../../charts/MonthlyChart";
import MonthlyPieChart from "../../charts/MonthlyPieChart";

const Starter = () => {
  return (
    <div>
      <Row>
        <Col sm={8} lg={8}>
          {/* <EmailQuerter/> */}
          {/* <FinancialTable /> */}
          <ContentHeader />
        </Col>
        <Col sm={4} lg={4}>
          {" "}
          {/* Adjusted from 12 to 4 to make the sum 12 */}
          <EmailedToday />
        </Col>
      </Row>
      <Row>
        <Col sm={4} lg={4}>
          {" "}
          {/* Adjusted from 3 to 4 */}
          {/* <EmailedToday />
          <UserViseEmail /> */}
          <MonthlyChart />
        </Col>
        <Col sm={8} lg={8}>
          {" "}
          {/* Adjusted from 6 to 8 */}
          <ClosingDeals />
        </Col>
      </Row>
      <Row>
        <Col sm={8} lg={8}>
          {/* <EmailQuerter/> */}
          <FinancialTable />
        </Col>
        <Col sm={4} lg={4}>
          {/* <EmailQuerter/> */}
          <MonthlyPieChart />
        </Col>
      </Row>
    </div>

    // <div>
    //     <Row>
    //     <Col sm={8} lg={8}>
    //             {/* <EmailQuerter/> */}
    //             {/* <FinancialTable /> */}
    //         <ContentHeader />
    //     </Col>
    //     <Col sm={12} lg={3}>
    //         <EmailedToday />
    //         </Col>
    //     </Row>
    //     <Row>
    //         <Col sm={3} lg={3}>
    //             <EmailedToday />
    //             <UserViseEmail />
    //         </Col>
    //         <Col sm={6} lg={8}>
    //             <ClosingDeals />
    //         </Col>
    //         {/* <Col sm={3} lg={3}>
    //             <UserViseEmail />
    //         </Col> */}
    //         {/* <Col sm={3} lg={3}>
    //             <UserViseWeeklyEmail />
    //         </Col>
    //         <Col sm={3} lg={3}>
    //         <EmailedToday />
    //         </Col> */}
    //     </Row>
    //     {/* <Row>
    //         <Col sm={6} lg={4}>
    //         <EmailedToday />
    //         </Col>
    //         <Col sm={6} lg={4}>
    //             <Feeds />
    //         </Col>
    //         <Col sm={6} lg={4}>
    //             <Feeds />
    //         </Col>
    //     </Row> */}
    //     {/* <Row>
    //         <Col sm={12}>
    //             <Users />
    //         </Col>
    //     </Row> */}
    //     <Row>
    //     <Col sm={12}>
    //             {/* <EmailQuerter/> */}
    //             <FinancialTable />
    //         </Col>
    //     </Row>
    // </div>
  );
};

export default Starter;
